import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';
import { format } from 'app/shared/utils/string.util';
import { InformixLinkedService } from '../linkedservice/informix.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.informix.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.InformixTable_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.InformixTable_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: InformixLinkedService.MODEL // Linked service redefined
        }
    }
})
export class InformixTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
